import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Users, BarChart3 } from 'lucide-react';
export function Slide7FirstPilot() {
  return <div className="h-full w-full bg-[#F8F9FA] text-[#2D3748] flex flex-col p-12 md:px-24 md:pt-16 md:pb-24 relative overflow-hidden" data-id="element-215">
      <header className="mb-12" data-id="element-216">
        <motion.h2 className="text-4xl md:text-5xl font-bold text-[#1A202C] mb-4" initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-217">
          Recommended first pilot:{' '}
          <span className="text-[#E60012]" data-id="element-218">Pre-Congress Insight Snak</span>
        </motion.h2>
        <motion.p className="text-xl text-[#4A5568] font-light max-w-3xl" initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-219">
          A low-risk way to test HCP interest before the larger ECHO or UEGW
          congress activity.
        </motion.p>
      </header>

      <main className="flex-1 flex items-center justify-between gap-12" data-id="element-220">
        <div className="flex-1 space-y-8" data-id="element-221">
          <motion.div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-222">
            <div className="flex items-center gap-3 mb-4" data-id="element-223">
              <FileText className="w-6 h-6 text-[#E60012]" data-id="element-224" />
              <h3 className="text-xl font-bold text-[#1A202C]" data-id="element-225">Example Quiz</h3>
            </div>
            <p className="text-[#4A5568] font-medium mb-6" data-id="element-226">
              "Before ECHO, what do you see as the biggest challenge in IBD
              patient management today?"
            </p>
            <div className="space-y-3" data-id="element-227">
              {['A. Identifying the right treatment earlier', 'B. Achieving long-term disease control', 'C. Supporting adherence and follow-up'].map((opt, i) => <div key={i} className="p-3 bg-gray-50 rounded-lg border border-gray-200 text-sm text-[#2D3748]" data-id="element-228">
                  {opt}
                </div>)}
            </div>
          </motion.div>

          <motion.div className="flex gap-6" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} data-id="element-229">
            <div className="flex-1 bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start gap-4" data-id="element-230">
              <div className="p-3 bg-[#6B46C1]/10 rounded-lg shrink-0" data-id="element-231">
                <Users className="w-6 h-6 text-[#6B46C1]" data-id="element-232" />
              </div>
              <div data-id="element-233">
                <h4 className="font-bold text-[#1A202C] text-sm mb-1" data-id="element-234">
                  Peer Result Moment
                </h4>
                <p className="text-xs text-[#4A5568]" data-id="element-235">
                  See how your peers answered
                </p>
              </div>
            </div>
            <div className="flex-1 bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start gap-4" data-id="element-236">
              <div className="p-3 bg-[#E60012]/10 rounded-lg shrink-0" data-id="element-237">
                <BarChart3 className="w-6 h-6 text-[#E60012]" data-id="element-238" />
              </div>
              <div data-id="element-239">
                <h4 className="font-bold text-[#1A202C] text-sm mb-1" data-id="element-240">
                  Outputs
                </h4>
                <p className="text-xs text-[#4A5568]" data-id="element-241">
                  Knowledge gaps, topic interest, campaign recommendation
                </p>
              </div>
            </div>
          </motion.div>

          <motion.p className="text-[#4A5568] font-medium border-l-4 border-[#E60012] pl-4" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.8
        }} data-id="element-242">
            This pilot does not require a full congress transformation. It gives
            Takeda and its agencies early data that can sharpen the main
            congress strategy.
          </motion.p>
        </div>

        {/* Mobile Mockup */}
        <motion.div className="w-[320px] h-[640px] bg-white rounded-[40px] shadow-2xl border-[8px] border-gray-900 relative overflow-hidden shrink-0" initial={{
        opacity: 0,
        x: 50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-243">
          {/* Notch */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-6 bg-gray-900 rounded-b-xl z-20" data-id="element-244" />

          {/* Screen Content */}
          <div className="w-full h-full bg-[#F8F9FA] flex flex-col" data-id="element-245">
            <div className="bg-[#E60012] text-white p-6 pt-12 pb-8 rounded-b-3xl shadow-md relative z-10" data-id="element-246">
              <div className="text-xs font-bold uppercase tracking-wider mb-2 opacity-80" data-id="element-247">
                ECHO Congress 2026
              </div>
              <h3 className="text-xl font-bold leading-tight" data-id="element-248">
                What is your biggest challenge in IBD management?
              </h3>
            </div>

            <div className="p-6 flex-1 flex flex-col gap-4 mt-4" data-id="element-249">
              {['Identifying the right treatment earlier', 'Achieving long-term disease control', 'Supporting adherence and follow-up'].map((opt, i) => <div key={i} className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex items-center justify-between group hover:border-[#E60012] transition-colors cursor-pointer" data-id="element-250">
                  <span className="text-sm font-medium text-[#2D3748]" data-id="element-251">
                    {opt}
                  </span>
                  <div className="w-5 h-5 rounded-full border-2 border-gray-300 group-hover:border-[#E60012]" data-id="element-252" />
                </div>)}
            </div>

            <div className="p-6 bg-white border-t border-gray-100" data-id="element-253">
              <button className="w-full py-3 bg-[#E60012] text-white rounded-xl font-bold text-sm shadow-md" data-id="element-254">
                Submit & See Results
              </button>
            </div>
          </div>
        </motion.div>
      </main>
    </div>;
}